/**
 *  @class
 *  @function MegaMenuSidebar
 */
if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.mega-menu-sidebar--button');
      this.content = this.querySelectorAll('.mega-menu-sidebar--content-inner:not([data-parent-overview])');
      this.overview = this.querySelector('.mega-menu-sidebar--content-inner[data-parent-overview]');
      this.panelHome = this.querySelector('.mega-menu-sidebar--content');
      this.dropdown = this.closest('.sub-menu');
      this.overviewLinks = this.querySelectorAll('.mega-menu-sidebar--has-children[data-mega-menu-panel-index]');
      this.showOverviewOnParentHover = this.dataset.showOverviewOnParentHover === 'true';
      this.showFirstPanelOnParentHover = this.dataset.showFirstPanelOnParentHover === 'true';
      this.keepOverviewOnPanelHover = this.dataset.keepOverviewOnPanelHover === 'true';
      this.closePanelTimer = null;
      this.panelScrollTimer = null;
      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseover', (event) => {
          this.onHover(event, button, i);
        });
      });
      this.overviewLinks.forEach((link) => {
        const card = link.closest('li') || link;
        card.addEventListener('mouseenter', () => {
          const panelIndex = Number(link.dataset.megaMenuPanelIndex);
          const panel = this.content[panelIndex];
          if (!panel || !panel.querySelector('li')) {
            this.clearActivePanel({ keepOverview: true });
            return;
          }
          this.activatePanel(panelIndex, link);
        });
        card.addEventListener('mouseleave', () => {
          this.schedulePanelClose(link);
        });
      });
      this.images = this.querySelectorAll('img');
      this.parentMenuItem = this.closest('.menu-item-has-children');

      if (this.showOverviewOnParentHover && this.parentMenuItem) {
        this.parentMenuItem.addEventListener('mouseenter', () => {
          this.parentMenuItem.classList.remove('mega-menu-force-closed');
          this.activateOverview();
        });
        this.parentMenuItem.addEventListener('mouseleave', () => {
          this.closeDropdown({ forceClosed: false });
        });
      } else if (this.showFirstPanelOnParentHover && this.parentMenuItem) {
        this.parentMenuItem.addEventListener('mouseenter', () => {
          this.parentMenuItem.classList.remove('mega-menu-force-closed');
          this.activatePanel(0);
        });
        this.parentMenuItem.addEventListener('mouseleave', () => {
          this.closeDropdown({ forceClosed: false });
        });
      } else if (this.parentMenuItem) {
        this.parentMenuItem.addEventListener('mouseenter', () => {
          this.parentMenuItem.classList.remove('mega-menu-force-closed');
        });
        this.parentMenuItem.addEventListener('mouseleave', () => {
          this.closeDropdown({ forceClosed: false });
        });
      }
      this.parentMenuItem?.querySelectorAll('[data-mega-menu-close]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.closeDropdown({ forceClosed: true });
        });
      });
      this.querySelectorAll('.mega-menu-sidebar--content-container, .thb-full-menu--link').forEach((link) => {
        link.addEventListener('focus', () => {
          const panelIndex = Number(link.dataset.megaMenuPanelIndex);
          if (!Number.isNaN(panelIndex) && link.classList.contains('mega-menu-sidebar--has-children')) {
            this.activatePanel(panelIndex, link);
          }
        });
      });
      document.querySelectorAll('.thb-full-menu > li.menu-item-has-children').forEach((item) => {
        if (item !== this.parentMenuItem) {
          item.addEventListener('mouseenter', () => {
            this.closeDropdown({ forceClosed: false });
          });
        }
      });
      document.addEventListener('pointerover', (event) => {
        if (!this.contains(event.target) && !this.parentMenuItem?.contains(event.target)) {
          this.closeDropdown({ forceClosed: false });
        }
      });

      window.addEventListener('load', (event) => {
        this.unveilImages(this);
      });

      this.unveilImages(this);
    }

    onHover(event, button, i) {
      this.activatePanel(i);
    }

    activatePanel(i, trigger = null) {
      this.cancelPanelClose();
      if (this.overview && !this.keepOverviewOnPanelHover) {
        this.overview.classList.remove('active');
      } else if (this.overview) {
        this.overview.classList.add('active');
      }
      this.content.forEach((content, index) => {
        this.restorePanel(content);
          content.classList.remove('active');
          content.classList.remove('mega-menu-sidebar--card-panel', 'mega-menu-sidebar--card-panel-right');
          if (i == index) {
            if (this.keepOverviewOnPanelHover && trigger) {
              this.positionPanelUnderCard(content, trigger);
              this.setOverviewActiveCard(trigger);
            }
            content.classList.add('active');
          }
      });
      this.buttons.forEach((this_button, index) => {
        this_button.classList.remove('active');
      });
      if (this.buttons[i]) {
        this.buttons[i].classList.add('active');
      }
      this.unveilImages(this.content[i]);
    }

    positionPanelUnderCard(panel, trigger) {
      const item = trigger.closest('li');
      const overview = item?.closest('[data-parent-overview]');
      if (!item || !overview || !panel) {
        return;
      }

      const slot = document.createElement('li');
      slot.className = 'mega-menu-sidebar--panel-slot';
      const shell = document.createElement('div');
      shell.className = 'mega-menu-sidebar--panel-shell';
      const title = document.createElement('div');
      title.className = 'mega-menu-sidebar--panel-title';
      title.textContent = this.getPanelTitle(trigger);
      const prevButton = this.createScrollButton('previous');
      const nextButton = this.createScrollButton('next');
      shell.append(title, prevButton, panel, nextButton);
      slot.appendChild(shell);

      const rowEnd = this.findRowEndItem(item, overview);
      rowEnd.insertAdjacentElement('afterend', slot);
      panel.classList.add('mega-menu-sidebar--card-panel');
      this.updateScrollButtons(panel, prevButton, nextButton);
      prevButton.addEventListener('click', () => {
        panel.scrollBy({ left: -panel.clientWidth * 0.8, behavior: 'smooth' });
      });
      nextButton.addEventListener('click', () => {
        panel.scrollBy({ left: panel.clientWidth * 0.8, behavior: 'smooth' });
      });
      panel.addEventListener('scroll', () => {
        this.updateScrollButtons(panel, prevButton, nextButton);
      }, { passive: true });
      slot.addEventListener('mouseenter', () => {
        this.cancelPanelClose();
      });
      slot.addEventListener('mouseleave', () => {
        this.schedulePanelClose(trigger);
      });
      this.queuePanelIntoView(slot);
    }

    getPanelTitle(trigger) {
      const label = trigger.querySelector('.text-button, .product-card-title') || trigger;
      return label.textContent.replace(/\s+/g, ' ').trim();
    }

    restorePanel(panel) {
      const slot = panel.closest('.mega-menu-sidebar--panel-slot');
      if (slot && this.panelHome) {
        this.panelHome.appendChild(panel);
        slot.remove();
      }
    }

    setOverviewActiveCard(trigger) {
      if (!this.overview) {
        return;
      }

      this.overview.classList.add('mega-menu-sidebar--overview-has-active-card');
      this.overview.querySelectorAll('.mega-menu-sidebar--overview-card-active').forEach((item) => {
        item.classList.remove('mega-menu-sidebar--overview-card-active');
      });
      const item = trigger.closest('li');
      item?.classList.add('mega-menu-sidebar--overview-card-active');
    }

    clearOverviewActiveCard() {
      if (!this.overview) {
        return;
      }

      this.overview.classList.remove('mega-menu-sidebar--overview-has-active-card');
      this.overview.querySelectorAll('.mega-menu-sidebar--overview-card-active').forEach((item) => {
        item.classList.remove('mega-menu-sidebar--overview-card-active');
      });
    }

    queuePanelIntoView(slot) {
      this.cancelPanelClose();
      window.requestAnimationFrame(() => {
        this.scrollPanelIntoView(slot, 'smooth');
        window.requestAnimationFrame(() => {
          this.scrollPanelIntoView(slot, 'smooth');
        });
      });

      if (this.panelScrollTimer) {
        window.clearTimeout(this.panelScrollTimer);
      }
      this.panelScrollTimer = window.setTimeout(() => {
        this.scrollPanelIntoView(slot, 'smooth');
        this.panelScrollTimer = null;
      }, 180);
    }

    getPanelScrollContainer(slot) {
      const candidates = [this.panelHome, this.dropdown].filter(Boolean);
      return candidates.find((container) => {
        return container.scrollHeight > container.clientHeight + 2 && container.contains(slot);
      }) || this.panelHome || this.dropdown;
    }

    scrollPanelIntoView(slot, behavior = 'smooth') {
      const scrollContainer = this.getPanelScrollContainer(slot);
      if (!slot || !scrollContainer) {
        return;
      }

      const slotRect = slot.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const desiredTopOffset = Math.min(96, Math.max(24, containerRect.height * 0.18));
      const bottomOverflow = slotRect.bottom - containerRect.bottom + 32;
      const topOverflow = containerRect.top + desiredTopOffset - slotRect.top;

      if (bottomOverflow <= 0 && topOverflow <= 0) {
        return;
      }

      const targetScrollTop = scrollContainer.scrollTop + slotRect.top - containerRect.top - desiredTopOffset;
      const maxScrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
      const nextScrollTop = Math.max(0, Math.min(targetScrollTop, maxScrollTop));
      scrollContainer.scrollTo({ top: nextScrollTop, behavior });
      this.cancelPanelClose();
    }

    findRowEndItem(item, overview) {
      const rowTop = item.offsetTop;
      const items = Array.from(overview.children).filter((child) => {
        return child.matches('li:not(.mega-menu-sidebar--panel-slot)');
      });
      return items.filter((child) => child.offsetTop === rowTop).pop() || item;
    }

    createScrollButton(direction) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `mega-menu-sidebar--panel-arrow mega-menu-sidebar--panel-arrow-${direction}`;
      button.setAttribute('aria-label', direction === 'previous' ? 'Previous submenu items' : 'Next submenu items');
      button.innerHTML = direction === 'previous' ? '&#8249;' : '&#8250;';
      return button;
    }

    schedulePanelClose(trigger = null) {
      this.cancelPanelClose();
      this.closePanelTimer = window.setTimeout(() => {
        const slot = this.querySelector('.mega-menu-sidebar--panel-slot');
        if (slot?.matches(':hover') || trigger?.matches(':hover')) {
          return;
        }
        this.clearActivePanel({ keepOverview: true });
      }, 120);
    }

    cancelPanelClose() {
      if (this.closePanelTimer) {
        window.clearTimeout(this.closePanelTimer);
        this.closePanelTimer = null;
      }
    }

    updateScrollButtons(panel, prevButton, nextButton) {
      window.requestAnimationFrame(() => {
        const maxScroll = panel.scrollWidth - panel.clientWidth;
        panel.classList.toggle('mega-menu-sidebar--card-panel-centered', maxScroll <= 1);
        prevButton.disabled = panel.scrollLeft <= 1;
        nextButton.disabled = panel.scrollLeft >= maxScroll - 1;
        prevButton.hidden = maxScroll <= 1;
        nextButton.hidden = maxScroll <= 1;
      });
    }

    activateOverview() {
      if (!this.overview) {
        return;
      }

      this.content.forEach((content) => {
        this.restorePanel(content);
        content.classList.remove('active');
        content.classList.remove('mega-menu-sidebar--card-panel', 'mega-menu-sidebar--card-panel-right');
      });
      this.clearOverviewActiveCard();
      this.buttons.forEach((button) => {
        button.classList.remove('active');
      });
      this.overview.classList.add('active');
      this.unveilImages(this.overview);
    }

    clearActivePanel(options = {}) {
      this.cancelPanelClose();
      if (this.overview && !options.keepOverview) {
        this.overview.classList.remove('active');
      }
      this.content.forEach((content) => {
        this.restorePanel(content);
        content.classList.remove('active');
        content.classList.remove('mega-menu-sidebar--card-panel', 'mega-menu-sidebar--card-panel-right');
      });
      this.clearOverviewActiveCard();
      this.buttons.forEach((button) => {
        button.classList.remove('active');
      });
    }

    closeDropdown(options = {}) {
      this.clearActivePanel();
      if (options.forceClosed && this.parentMenuItem) {
        this.parentMenuItem.classList.add('mega-menu-force-closed');
      }
      if (this.parentMenuItem?.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }

    unveilImages(container) {
      if (!container || !window.lazySizes || !window.lazySizes.loader) {
        return;
      }

      container.querySelectorAll('img').forEach(function (image) {
        lazySizes.loader.unveil(image);
      });
    }
  }
  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}
